import api from "@/services/api";
import { useMutation } from "@tanstack/react-query";

export const useLogin = () => {
  return useMutation({
    mutationKey: ["login"],
    mutationFn: async (credentials: { email: string; password: string }) => {
      const response = await api.post("/accounts/login", credentials);
      return response.data;
    },
  });
};
